import { useState, useEffect } from "react";
import { AutoComplete, Input } from "antd";
import _ from "lodash";
import { SearchOutlined } from "@ant-design/icons";
import { searchAutoComplete } from "../../services/searchAutoCompleteService";
import { Select } from 'antd';
const { Option } = Select;

const Autocomplete = ({
  subject,
  labelField,
  valueField,
  placeholder,
  onSelect,
  onChange,
  value,
  prefixIcon = <SearchOutlined />,
  filterFn,
}) => {
  const [options, setOptions] = useState([]);

  const getListAutocomplete = async (searchText) => {
    const res = await searchAutoComplete(subject, searchText);

    if (res?.data?.code === "0000") {
      const { objectValue } = res.data;
      const filtered = filterFn ? objectValue.filter(filterFn) : objectValue;
      const mapValue = filtered.map((data, index) => {
        return {
          label: _.get(data, `${labelField? labelField : valueField}`),
          value: _.get(data, `${valueField}`),
          id: index,
          key: index,
        };
      });
      setOptions(mapValue);
    } else {
      setOptions([]);
    }
  };

  useEffect(() => {
    if (subject && valueField) {
      getListAutocomplete("");
    }
  }, [])

  return (
    <AutoComplete
      filterOption={true}
      mode="multiple"
      options={options}
      onChange={onChange}
      value={value}
      onSelect={onSelect}
      onSearch={(text) => getListAutocomplete(text)}
    >
      <Input placeholder={placeholder} prefix={prefixIcon} />
    </AutoComplete>
  );
};

const MultipleAutoComplete = ({
  className,
  multiple=true,
  subject,
  labelField,
  valueField,
  placeholder,
  value,
  onSelect,
  onChange,
  disabled
}) => {
  const [options, setOptions] = useState([]);

  const getListAutocomplete = async (searchText) => {
    const res = await searchAutoComplete(subject, searchText);

    if (res?.data?.code === "0000") {
      const { objectValue } = res.data;
      const mapValue = objectValue.map((data, index) => {
        return {
          label: _.get(data, `${labelField? labelField : valueField}`),
          value: _.get(data, `${valueField}`),
          id: index,
          key: index,
        };
      });
      setOptions(mapValue);
    } else {
      setOptions([]);
    }
  };

  useEffect(() => {
    if (subject && valueField) {
      getListAutocomplete("");
    }
  }, [])

  return (
    <Select
      className={className}
      allowClear
      showSearch={true}
      mode={multiple ? "multiple" : null}
      style={{ width: '100%' }}
      placeholder={placeholder}
      onSearch={getListAutocomplete}
      filterOption={false} // Disable built-in filtering to rely on custom handleSearch
      onChange={onChange} // Call the onChange prop passed from Form.Item
      value={value} // Make sure it is a controlled component
      disabled={disabled}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export { Autocomplete, MultipleAutoComplete };